module.exports = __webpack_public_path__ + "static/default-63a19caf1f0919431852a1115b272112.svg";